import type { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import type SwalType from 'sweetalert2/dist/sweetalert2.js';

type SwalModule = typeof SwalType;

type SwalFn = ((options: SweetAlertOptions) => Promise<SweetAlertResult>) & {
    DismissReason: SwalModule['DismissReason'];
    close: SwalModule['close'];
};

let swalPromise: Promise<SwalModule> | null = null;

const getSwal = () => {
    if (!swalPromise) {
        swalPromise = import('sweetalert2/dist/sweetalert2.js').then(
            m => m.default
        );
    }
    return swalPromise;
};

const swal: SwalFn = (async (options: SweetAlertOptions) => {
    const Swal = await getSwal();
    const route = useRoute();
    const analyticStore = useAnalyticsStore();

    // set "static" props once the module is loaded
    swal.DismissReason = Swal.DismissReason;
    swal.close = Swal.close;

    return Swal.fire(options).then(result => {
        analyticStore.trackAll('site-alert', {
            title: options.title,
            content: options.text,
            type: options.icon,
            path: route.fullPath,
        });
        return result;
    }) as Promise<SweetAlertResult>;
}) as SwalFn;

// optional: placeholders until first call loads the module
swal.DismissReason = {} as SwalFn['DismissReason'];
swal.close = (() => {}) as SwalFn['close'];

export default swal;
